import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OrderEntry, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';

@Component({
  selector: 'sd-compare-cart-product-item',
  templateUrl: './compare-cart-product-item.component.html',
  styleUrls: ['./compare-cart-product-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, UrlModule, MediaModule],
})
export class CompareCartProductItemComponent {
  @Input() item: OrderEntry;
  @Input() quantity: number;
}
